import { render, staticRenderFns } from "./ColorBandGouvBj.vue?vue&type=template&id=a1f4e138&scoped=true&"
import script from "./ColorBandGouvBj.vue?vue&type=script&lang=js&"
export * from "./ColorBandGouvBj.vue?vue&type=script&lang=js&"
import style0 from "./ColorBandGouvBj.vue?vue&type=style&index=0&id=a1f4e138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f4e138",
  null
  
)

export default component.exports